export const MAX_ELAPSED_OFFSET = 0.25;
export const PUSH_FORWARD_MS = 1000;
export const SYNC_ITERATIONS = 3;
